var exports = {
  "JW": "SignalStrengthIcon.module__svg___ZDRQWE",
  "wL": "SignalStrengthIcon.module__green___ZDRQWE",
  "D9": "SignalStrengthIcon.module__yellow___ZDRQWE",
  "T_": "SignalStrengthIcon.module__orange___ZDRQWE",
  "wv": "SignalStrengthIcon.module__red___ZDRQWE",
  "Xe": "SignalStrengthIcon.module__tertiary___ZDRQWE",
  "cQ": "SignalStrengthIcon.module__tertiaryMuted___ZDRQWE",
};

module.exports = exports;
